module.exports = __webpack_public_path__ + "img/shrewd-save-6.d6aee42b.jpg";